export default "__VITE_ASSET__e3e96bce__"